import { jsx as _jsx } from "react/jsx-runtime";
import { Html } from '@react-three/drei';
import React, { useMemo, useEffect, memo } from 'react';
import { useSelector } from 'react-redux';
import { COLORS } from '@/utils';
import { IComponentType } from '@r3f-component-data-structure';
import CSS from './DragElement.scss';
const DragElement = ({ dragState, position }) => {
    const isFaceLandmarkHovered = useSelector((state) => !!state.userReducer.activeFaceLandmark);
    const opacity = isFaceLandmarkHovered ? 0.4 : 0.9;
    const classes = useMemo(() => [CSS.DragElContainer], []);
    useEffect(() => {
        setTimeout(() => classes.push(CSS.DragShadow), 5);
    }, [classes]);
    const entityObj = useMemo(() => {
        const dragEl = document.getElementById(dragState.id);
        if (!dragEl)
            return;
        const domRect = dragEl.getBoundingClientRect();
        const { width, height } = domRect;
        return { dragEl, width, height };
    }, [dragState.id]);
    if (!entityObj)
        return null;
    let { width, height } = entityObj;
    const { dragEl } = entityObj;
    if (!dragState || !document.getElementById(dragState.id))
        return null;
    if (dragState.type === IComponentType.Text || dragState.type === IComponentType.Text3d || dragState.type === IComponentType.Button) {
        const entity = dragState.entity;
        switch (entity.type) {
            case IComponentType.Text: {
                return _jsx(Html, { position: position, children: _jsx("div", { className: CSS.DragElement, style: {
                            width: Math.round(width) + 8,
                            height,
                            opacity,
                            display: dragEl.style.display,
                            alignItems: dragEl.style.alignItems,
                            justifyContent: dragEl.style.justifyContent,
                            fontFamily: entity.fontFamily,
                            color: COLORS.midnight,
                            fontSize: dragEl.style.fontSize,
                            borderRadius: dragEl.style.borderRadius,
                            borderWidth: dragEl.style.borderWidth,
                            borderColor: dragEl.style.borderColor,
                            backgroundColor: 'none !important',
                        }, children: _jsx("span", { style: {
                                color: COLORS.midnight,
                                fontFamily: entity.fontFamily,
                                fontSize: dragEl.style.fontSize,
                            }, children: entity.text }) }) });
            }
            case IComponentType.Button: {
                return _jsx(Html, { position: position, children: _jsx("div", { className: CSS.DragElement, style: {
                            width: dragEl.style.width,
                            height: dragEl.style.height,
                            opacity,
                            display: dragEl.style.display,
                            alignItems: dragEl.style.alignItems,
                            justifyContent: dragEl.style.justifyContent,
                            fontFamily: dragEl.style.fontFamily,
                            borderRadius: dragEl.style.borderRadius,
                            borderWidth: dragEl.style.borderWidth,
                            borderColor: dragEl.style.borderColor,
                            backgroundColor: dragEl.style.backgroundColor,
                            backgroundImage: dragEl.style.backgroundImage,
                            backgroundSize: 'contain',
                            backgroundPositionX: 'center',
                            backgroundPositionY: 'center',
                            backgroundRepeat: 'no-repeat',
                        }, children: _jsx("span", { style: { color: dragEl.style.color }, children: entity.svgUrl ? '' : entity.text }) }) });
            }
            case IComponentType.Text3d: {
                // const entityRatio = entity.scale[0] / entity.scale[1];
                // if (entityRatio > 0) height = width / entityRatio;
                //else width = height * entityRatio;
                // const standardTextureImageUrl = 'https://d1sonmy4sf0d9y.cloudfront.net/image/dev6-a2922d5ead744b75b385bc88fb352b9e/img'
                // const normalTextureImageUrl = 'https://d1sonmy4sf0d9y.cloudfront.net/image/dev6-3195f757844b4cff95a0730526b518b2/img'
                // const imgUrl = entity.material === 'standard' ? standardTextureImageUrl : normalTextureImageUrl;
                return _jsx(Html, { position: position, children: _jsx("div", { className: CSS.DragElement, style: {
                            width: Math.round(width) + 8,
                            height,
                            opacity,
                            display: dragEl.style.display,
                            alignItems: dragEl.style.alignItems,
                            justifyContent: dragEl.style.justifyContent,
                            fontFamily: entity.fontFamily,
                            color: COLORS.midnight,
                            fontSize: dragEl.style.fontSize,
                            borderRadius: dragEl.style.borderRadius,
                            borderWidth: dragEl.style.borderWidth,
                            borderColor: dragEl.style.borderColor,
                            backgroundColor: 'none !important',
                        }, children: _jsx("span", { style: {
                                color: COLORS.midnight,
                                fontFamily: entity.fontFamily,
                                fontSize: dragEl.style.fontSize,
                            }, children: entity.text }) }) });
            }
        }
    }
    else {
        switch (dragState.type) {
            case IComponentType.Image: {
                // const entityRatio = entity.scale[0] / entity.scale[1];
                // if (entityRatio > 0) height = width / entityRatio;
                // else width = height * entityRatio;
                return _jsx(Html, { className: CSS.DragOuter, position: position, children: _jsx("img", { className: CSS.DragImage, style: { width, height, opacity }, src: dragState.mediaFile.thumbnailUrl }) });
            }
            case IComponentType.Model3d: {
                return _jsx(Html, { className: CSS.DragOuter, position: position, children: _jsx("img", { className: CSS.DragImage, style: { width: dragState.dimensions[0], height: dragState.dimensions[1], opacity }, src: dragState.mediaFile.thumbnailUrl }) });
            }
            case IComponentType.Video: {
                // const entityRatio = entity.scale[0] / entity.scale[1];
                // if (entityRatio > 0) height = width / entityRatio;
                // else width = height * entityRatio;
                return _jsx(Html, { className: CSS.DragOuter, position: position, children: _jsx("img", { className: CSS.DragImage, style: { width: dragState.dimensions?.[0], height: dragState.dimensions?.[1], opacity }, src: dragState.mediaFile.thumbnailUrl }) });
            }
        }
    }
    return null;
};
export default memo(DragElement);
